import React, { useEffect, useState } from 'react'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { Text, ListItemContainer, Table, TableData, TextLink } from '../UI/generalLayout/Layout.styled'
import Colors from '../../constants/Colors';
import { StyledSwitch } from '../companyListItem/CompanyListItem.styled';
import { ItemInfoContainer, MobileContainer, SwitchContainer, ViewEditContainer } from '../companyListItem/CompanyListItemMobile.styled';
import ActivateInactivateModal from '../activateInactivateModal/ActivateInactivateModal';
import { MdCheck, MdClose } from 'react-icons/md';

interface IVitalSignListItem {
    id: string;
    name: string;
    tipoCampo: string;
    isPadrao: boolean;
    isActiveRegister: boolean;
    onEdit: any;
    onView: any;
    onActivateInactivate: any;
}

const VitalSignListItem = ({ name, id, tipoCampo, isPadrao, isActiveRegister, onEdit, onView, onActivateInactivate }: IVitalSignListItem) => {
    const { isMobile } = useResponsiveInfo()
    const [isActive, setIsActive] = useState(isActiveRegister)
    const [showModalAtivarInativar, setShowModalAtivarInativar] = useState(false)

    useEffect(() => {
        setIsActive(isActiveRegister)
    }, [isActiveRegister])

    const handleActivateInactivate = async () => {
        try {
            onActivateInactivate(id, !isActive)
            setIsActive(prev => !prev)
            setShowModalAtivarInativar(false)
        } catch (error: any) { }
    }

    return (
        <>
            <ListItemContainer disabled={!isActive} style={{ marginTop: isMobile ? 16 : 0 }}>
                {!isMobile ?
                    (<Table>
                        <TableData width={'40%'}>
                            <Text bold color={isActive ? '' : Colors.GRAY400}>{name}</Text>
                        </TableData>
                        <TableData width={'20%'}>
                            <Text color={isActive ? '' : Colors.GRAY400}>{tipoCampo}</Text>
                        </TableData>
                        <TableData width={'10%'} alignCenter={true}>
                            {isPadrao ? <MdCheck color={Colors.SPM500} size={20} /> : <MdClose color={Colors.GRAY400} size={20} />}
                        </TableData>
                        <TableData width={'10%'} alignRight={true}>
                            <TextLink
                                style={{ fontWeight: 'bold' }}
                                color={Colors.SPM500}
                                disabled={!isActive}
                                onClick={!isActive ? undefined : onEdit}>
                                EDITAR
                            </TextLink>
                        </TableData>
                        <TableData width={'10%'} alignRight={true}>
                            <TextLink
                                style={{ fontWeight: 'bold' }}
                                color={Colors.SPM500}
                                onClick={onView}>
                                VISUALIZAR
                            </TextLink>
                        </TableData>
                        <TableData width={'10%'} alignRight={true}>
                            <StyledSwitch
                                style={{ color: Colors.SPM600 }}
                                checked={isActive}
                                onChange={() => setShowModalAtivarInativar(true)}
                            />
                        </TableData>
                    </Table>)
                    :
                    (<MobileContainer>
                        <ItemInfoContainer>
                            <Text bold>{name}</Text>
                            <Text style={{ fontSize: 12 }}>Tipo: {tipoCampo}</Text>
                            <ViewEditContainer>
                                <TextLink
                                    disabled={!isActive}
                                    bold
                                    color={Colors.SPM500}
                                    style={{ fontSize: 12 }}
                                    onClick={!isActive ? undefined : onEdit}>
                                    EDITAR
                                </TextLink>
                                <TextLink
                                    bold
                                    color={Colors.SPM500}
                                    style={{ fontSize: 12 }}
                                    onClick={onView}>
                                    VISUALIZAR
                                </TextLink>
                            </ViewEditContainer>
                        </ItemInfoContainer>

                        <SwitchContainer>
                            <StyledSwitch
                                sx={{ width: 60 }}
                                style={{ color: Colors.SPM600, width: 45 }}
                                checked={isActive}
                                onChange={() => setShowModalAtivarInativar(true)}
                            />
                        </SwitchContainer>
                    </MobileContainer>)}
            </ListItemContainer>
            <ActivateInactivateModal
                isActivate={!isActive}
                visible={showModalAtivarInativar}
                onCancel={() => { setShowModalAtivarInativar(false) }}
                onConfirmCancellation={handleActivateInactivate}
                ativarButtonMsg={`Ativar`}
                inativarButtonMsg={`Inativar`}
                modalMsg={`Tem certeza que deseja ${isActive ? 'inativar' : 'ativar'} o sinal vital "${name}"?`}
            />
        </>
    )
}

export default VitalSignListItem
